import React from 'react';

export function ServicePlanPriceDisplay({
  price,
  cycle,
  priceClassName = 'text-2xl sm:text-3xl xl:text-4xl font-black text-white tabular-nums tracking-tight leading-tight break-words',
  wrapperClassName = 'mb-5 min-h-[3.25rem] sm:min-h-[3.5rem] flex flex-col justify-end'
}) {
  return (
    <div className={wrapperClassName}>
      <span className={priceClassName}>{price?.label}</span>
      {cycle === 'annual' && price?.savingsLine ? (
        <p className="text-xs text-emerald-400/90 font-semibold mt-1.5">{price.savingsLine}</p>
      ) : null}
      {cycle === 'annual' && price?.equivalentMonthlyLine ? (
        <p className="text-xs text-white/40 mt-1 font-light">{price.equivalentMonthlyLine}</p>
      ) : null}
    </div>
  );
}
